import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { ClosingCountdown } from '../../../models/FlowOfFunds/flow-of-funds.model';
import { formatLongBusinessDatePt } from '../../../slices/marketplace/timeline/utils/timeline-dates';
import './ClosingTickler.scss';

const IMMINENT_DAYS_REMAINING = 1;

export interface ClosingTicklerProps {
    closing?: ClosingCountdown | null;
}

const getCountdownHeadline = (daysRemaining: number): string => {
    if (daysRemaining === 0) {
        return 'Closing today';
    }
    if (daysRemaining === 1) {
        return '1 day to closing';
    }
    return `${daysRemaining} days to closing`;
};

export const ClosingTickler = ({ closing }: ClosingTicklerProps) => {
    if (!closing || closing.isEngagementClosed) {
        return null;
    }

    if (!closing.officialClosingDate) {
        return (
            <div className="ff-tickler ff-tickler--pending">
                <div className="ff-tickler__icon">
                    <FontAwesomeIcon icon={faCalendarDays} />
                </div>
                <div className="ff-tickler__body">
                    <div className="ff-tickler__headline">
                        Closing date not yet agreed
                    </div>
                    <div className="ff-tickler__detail">
                        {closing.defaultClosingDate
                            ? `Default target date · ${formatLongBusinessDatePt(
                                  closing.defaultClosingDate
                              )}`
                            : 'No closing date has been proposed yet.'}
                    </div>
                </div>
            </div>
        );
    }

    const daysRemaining = closing.daysRemaining ?? 0;
    if (daysRemaining < 0) {
        return null;
    }

    const isImminent = daysRemaining <= IMMINENT_DAYS_REMAINING;

    return (
        <div
            className={
                isImminent ? 'ff-tickler ff-tickler--imminent' : 'ff-tickler'
            }>
            <div className="ff-tickler__icon">
                <FontAwesomeIcon icon={faCalendarDays} />
            </div>
            <div className="ff-tickler__body">
                <div className="ff-tickler__headline">
                    {getCountdownHeadline(daysRemaining)}
                </div>
                <div className="ff-tickler__detail">
                    {`Official closing date · ${formatLongBusinessDatePt(
                        closing.officialClosingDate
                    )}`}
                </div>
            </div>
        </div>
    );
};
